import { render, staticRenderFns } from "./app.component.vue?vue&type=template&id=472c27fa&scoped=true&"
import script from "./app.component.js?vue&type=script&lang=js&"
export * from "./app.component.js?vue&type=script&lang=js&"
import style0 from "./app.component.scss?vue&type=style&index=0&id=472c27fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472c27fa",
  null
  
)

export default component.exports